import {
  InfoPanelTitle,
  InfoPanelDescription,
  InfoPanelLinks,
  InfoPanelFooter,
} from '@/features/jobs/details/tax-type/tax-prep-organizer/components/InfoPanel'

export function EinInfoContent() {
  return (
    <>
      <InfoPanelTitle>Employer Identification Number (EIN)</InfoPanelTitle>
      <InfoPanelDescription>
        <p>
          An EIN is a tax ID issued by the IRS for certain types of businesses,
          including those with employees or those registered as an LLC
          (depending on structure).
        </p>
        <p>
          If your business operates under your own name and you never applied
          for an EIN, it&apos;s normal not to have one and you can leave this
          blank. You can check prior tax returns, IRS letters, or business
          registration documents if you&apos;re unsure.
        </p>
      </InfoPanelDescription>
      <InfoPanelFooter>
        <InfoPanelLinks
          links={[
            {
              label: 'Do you need an EIN?',
              url: 'https://www.irs.gov/businesses/small-businesses-self-employed/when-to-get-a-new-ein',
            },
          ]}
        />
      </InfoPanelFooter>
    </>
  )
}
